module.exports = __webpack_public_path__ + "static/photo13@2x-e42a83f1be74f1f9c64816e0dad2e0fc.png";